import React from "react";
import { ThreeDots } from "react-loader-spinner";

function LoaderForSearch() {
  return (
    <ThreeDots
      height="30"
      width="50"
      radius="9"
      color="#1c74d0"
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClassName=""
      visible={true}
    />
  );
}

export default LoaderForSearch;
